import { createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Value } from '@utils/constants';
import { IListRes } from '@interfaces/apis/response-data';
import paths from '@utils/constants/paths';
import { axios } from '@utils/lib';

export const getAppKeyListAsync = createAsyncThunk(
  'api/getAppKeyListAsync',
  async (query: IBaseQuery, { rejectWithValue }) => {
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
      pageSize: String(query.pageSize ?? Value.TABLE_PAGE_SIZE),
      order: 'DESC',
    };
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IAppKey>>(
        Enums.HTTP_METHOD.GET,
        paths.APP_KEY_LIST + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createAppKeyAsync = createAsyncThunk(
  'api/createAppKeyAsync',
  async (body: ICreateAppKey, { rejectWithValue }) => {
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        paths.APP_KEY,
        body
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailAppKeyAsync = createAsyncThunk(
  'api/getDetailAppKeyAsync',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await axios.request<IGetDetailAppkey[]>(
        Enums.HTTP_METHOD.GET,
        paths.APP_KEY + '/' + id
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAppKeyAsync = createAsyncThunk(
  'api/deleteAppKeyAsync',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.DELETE,
        paths.APP_KEY + '/' + id
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateManyAppKeyAsync = createAsyncThunk(
  'api/updateManyAppKeyAsync',
  async ({ id, body }: IUpdateManyAppKey, { rejectWithValue }) => {
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PUT,
        paths.APP_KEY + '/' + id,
        { apiPublics: body }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAppKeyAsync = createAsyncThunk(
  'api/updateAppKeyAsync',
  async ({ id, body }: IUpdateAppKey, { rejectWithValue }) => {
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PUT,
        paths.APP_KEY_PERMISSION.replace(':id', id),
        body
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListApiAsync = createAsyncThunk(
  'api/getListApiAsync',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.request<IAppKeyPermission[]>(
        Enums.HTTP_METHOD.GET,
        paths.APP_LIST
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
